export const cities = ["Milano", "Firenze", "Napoli", "Roma", "Salerno"]
